import { render, staticRenderFns } from "./CotacaoFreteTransportadoras.vue?vue&type=template&id=04b40dcf"
import script from "./CotacaoFreteTransportadoras.vue?vue&type=script&lang=js"
export * from "./CotacaoFreteTransportadoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports